/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How streak freezes are acquired
 * @export
 */
export const StreakFreezeEarnRate = {
    PURCHASE: 'PURCHASE',
    MILESTONE: 'MILESTONE',
    BOTH: 'BOTH'
} as const;
export type StreakFreezeEarnRate = typeof StreakFreezeEarnRate[keyof typeof StreakFreezeEarnRate];


export function instanceOfStreakFreezeEarnRate(value: any): boolean {
    for (const key in StreakFreezeEarnRate) {
        if (Object.prototype.hasOwnProperty.call(StreakFreezeEarnRate, key)) {
            if (StreakFreezeEarnRate[key as keyof typeof StreakFreezeEarnRate] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakFreezeEarnRateFromJSON(json: any): StreakFreezeEarnRate {
    return StreakFreezeEarnRateFromJSONTyped(json, false);
}

export function StreakFreezeEarnRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakFreezeEarnRate {
    return json as StreakFreezeEarnRate;
}

export function StreakFreezeEarnRateToJSON(value?: StreakFreezeEarnRate | null): any {
    return value as any;
}

export function StreakFreezeEarnRateToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakFreezeEarnRate {
    return value as StreakFreezeEarnRate;
}

